import { create } from "zustand";
import { persist } from "zustand/middleware";
import { useAppStore } from "@/store/useAppStore";

export const TEAM_MEMBERS = [];
export const teamActivity = [];

export const useTeamStore = create(persist((set) => ({
  activeMemberId: null,
  setActiveMemberId: (id) => set({ activeMemberId: id }),
  assistantName: "Maya",
  setAssistantName: (name) => set({ assistantName: name }),
  instanceType: "private-saas",
  setInstanceType: (t) => set({ instanceType: t }),
  invitedMembers: [],
  addInvitedMember: (m) => set((s) => ({
    invitedMembers: [...s.invitedMembers, {
      ...m,
      id: `inv-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
      status: "Invited",
      invitedAt: Date.now(),
    }],
  })),
  clearInvitedMembers: () => set({ invitedMembers: [] }),
}), { name: "sellix.team.v1" }));

export const useActiveMember = () => {
  const { auth } = useAppStore();
  if (!auth?.user) return null;
  const name = auth.user.name || auth.user.email || "User";
  const parts = name.split(/\s+/).filter(Boolean);
  return {
    id: auth.user.email || "self",
    name,
    first: parts[0] || name,
    role: auth.server?.role || "Owner",
    title: auth.server?.role || "Owner",
    color: "from-indigo-500 to-violet-600",
    lastActive: "now",
    initials: auth.user.initials,
  };
};

import { useAssistantName as _useAssistantName } from "@/hooks/useAssistantName";
export const useAssistantName = _useAssistantName;

export function memberFromApiRow(row) {
  const name = row.display_name || row.email || "";
  const first = name.split(" ")[0] || name;
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const initials = parts.length >= 2
    ? (parts[0][0] + parts[1][0]).toUpperCase()
    : name.trim().slice(0, 2).toUpperCase() || "?";
  return {
    id: row.id || row.user_id,
    name,
    first,
    email: row.email,
    role: row.role || "member",
    title: row.role || "member",
    color: "from-indigo-500 to-violet-600",
    initials,
  };
}
